<div class="modal-main" [formGroup]="formGroup">
  <ng-container *ngIf="stepper === 1">
    <app-account-details
      formGroupName="accountDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (siteListChange)="siteList = $event"
      (submitToParent)="submitToParent()"
    >
    </app-account-details>
  </ng-container>

  <ng-container *ngIf="stepper === 2">
    <app-account-password-change
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(SuccessMessage)]="SuccessMessage"
    >
    </app-account-password-change>
  </ng-container>

  <ng-container *ngIf="stepper === 3">
    <app-account-name-change
      formGroupName="accountChangeName"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(SuccessMessage)]="SuccessMessage"
    >
    </app-account-name-change>
  </ng-container>

  <ng-container *ngIf="stepper === 4">
    <app-account-phone-change
      formGroupName="accountChangePhone"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(SuccessMessage)]="SuccessMessage"
      [email]="email"
    >
    </app-account-phone-change>
  </ng-container>

  <ng-container *ngIf="stepper === 5">
    <app-completed
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [SuccessMessage]="SuccessMessage"
    >
    </app-completed>
  </ng-container>

  <ng-container *ngIf="stepper === 6">
    <app-account-profile-change
      [dialogRef]="dialogRef"
      [(profileImageSrc)]="profileImageSrc"
      [(stepper)]="stepper"
      [(SuccessMessage)]="SuccessMessage"
    >
    </app-account-profile-change>
  </ng-container>

  <ng-container *ngIf="stepper === 7">
    <app-delete-account-confirm [dialogRef]="dialogRef" [(stepper)]="stepper">
    </app-delete-account-confirm>
  </ng-container>

  <ng-container *ngIf="stepper === 8">
    <app-delete-account-verify [dialogRef]="dialogRef" [(stepper)]="stepper">
    </app-delete-account-verify>
  </ng-container>

  <ng-container *ngIf="stepper === 9">
    <app-delete-account-success [dialogRef]="dialogRef" [(stepper)]="stepper">
    </app-delete-account-success>
  </ng-container>

  <ng-container *ngIf="stepper === 10">
    <app-delete-account-unable
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [siteList]="siteList"
    >
    </app-delete-account-unable>
  </ng-container>
</div>
